import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { ACTIONS } from "../../../../constants/Constants";
import { Checkbox } from "@fluentui/react";
import CustomCheckBox from "../HeaderFileChecks/CustomCheckBox";

const PriorsStudiesSettings = (props) => {
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    const clientList = props.showPriorsStudiesList.filter(
      (client) => !client.showPriorsStudies
    );
    console.log(clientList);
    if (clientList.length !== 0) setSelectAll(false);
    else setSelectAll(true);
  }, []);

  const handleSelectAllCheckboxClick = (e) => {
    props.setShowPriorsStudiesList((clientList) => {
      const updatedClientList = clientList.map((client) => {
        return { ...client, showPriorsStudies: !selectAll };
      });
      return updatedClientList;
    });

    setSelectAll((prev) => !prev);
  };

  const handleClientClick = (isChecked, id) => {
    props.setShowPriorsStudiesList((clientList) => {
      const updatedClientList = clientList.map((client) => {
        if (client.id === id) {
          return { ...client, showPriorsStudies: isChecked };
        } else {
          return client;
        }
      });
      return updatedClientList;
    });
  };

  return (
    <>
      <div className="tab-section">
        <div style={{ paddingLeft: "0px !important" }}>
          <section
            className="sectionA"
            style={{ marginTop: "1.5rem", marginBottom: "1rem" }}
          >
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("hospital.show-priors-settings")}
            </p>
          </section>
        </div>
        {props.action === ACTIONS.VIEW && (
          <>
            <div
              style={{
                display: "flex",
                maxHeight: "40px",
                marginBottom: "1rem",
              }}
            >
              <div
                className="ms-sm12 ms-lg3 ms-xl3"
                style={{ paddingLeft: "0px !important", fontSize: "14px" }}
              >
                <p className="single-line-form-field-key">
                  {props.values.name}
                </p>
              </div>
              <div className="ms-sm12 ms-lg8 ms-xl4">
                <p id="show-priors-studies-value" className="single-line-form-field-key">
                  {props.values.showPriorsStudies ? "Yes" : "No"}
                </p>
              </div>
            </div>

            <div className="ms-Grid-row" dir="ltr">
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  marginLeft: "8px",
                }}
              >
                {t("hospital.clients")}
              </span>
            </div>
            {props.showPriorsStudiesList?.length === 0 && (
              <div className="ms-Grid-row" dir="ltr">
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    marginLeft: "8px",
                  }}
                >
                  {t("user.no-firm-available")}
                </span>
              </div>
            )}
            <div className="ms-Grid-row" dir="ltr">
              {props.showPriorsStudiesList?.map((client, index) => {
                return (
                  <>
                    <div
                      key={index}
                      className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4"
                      style={{ display: "flex" }}
                    >
                      <div
                        style={{
                          display: "block",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <Checkbox
                          key={client.id}
                          label={client.name}
                          name={client.name}
                          onChange={(e, isChecked) =>
                            handleClientClick(isChecked, client.id)
                          }
                          checked={client.showPriorsStudies}
                          disabled
                        />
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </>
        )}
        {props.action === ACTIONS.EDIT && (
          <>
            <div className="ms-Grid-row" dir="ltr">
              <div
                style={{
                  display: "flex",
                  maxHeight: "40px",
                  marginBottom: "1rem",
                }}
              >
                <div
                  className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3"
                  style={{ paddingLeft: "0px !important", fontSize: "14px" }}
                >
                  <p className="single-line-form-field-key">
                    {props.values.name}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div id="show-priors-studies-checkbox" style={{ marginTop: "5px" }}>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.showPriorsStudies}
                      onChangeCustom={() => {
                        props.values.showPriorsStudies =
                          !props.values.showPriorsStudies;
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="" dir="ltr">
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    marginLeft: "8px",
                  }}
                >
                  {t("hospital.clients")}
                </span>
              </div>
              {props.showPriorsStudiesList?.length === 0 && (
                <div className="" dir="ltr">
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      marginLeft: "8px",
                    }}
                  >
                    {t("user.no-firm-available")}
                  </span>
                </div>
              )}
              {props.showPriorsStudiesList?.length > 0 && (
                <div className="">
                  <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4">
                    <Checkbox
                      label="Select All"
                      onChange={handleSelectAllCheckboxClick}
                      id="all"
                      checked={selectAll}
                    />
                  </div>
                </div>
              )}
              {props.showPriorsStudiesList?.map((client, index) => {
                return (
                  <>
                    <div
                      key={index}
                      className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4"
                      style={{ display: "flex" }}
                    >
                      <div
                        style={{
                          display: "block",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <Checkbox
                          key={client.id}
                          label={client.name}
                          name={client.name}
                          onChange={(e, isChecked) =>
                            handleClientClick(isChecked, client.id)
                          }
                          checked={client.showPriorsStudies}
                        />
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PriorsStudiesSettings;
